import styled from 'styled-components';
import { breakpoints } from '../../utils/util-breakpoints';
import EPModal from '@/comp/EPModal';
import { CustomThemeToken } from '@/theme';

export const StyledEPModal = styled(EPModal)`
  .ant-modal-content {
    height: fit-content;
    .ant-modal-body {
      padding: 25px;
    }
  }

  p.close-modal-title {
    font-weight: bold;
  }

  p.close-modal-body {
    padding-top: 10px;
  }

  div.close-button-container {
    display: flex;
    margin-top: 25px;
    align-items: center;
    justify-content: end;
  }

  .close-button {
    margin-left: 7px;
  }
`;

export const SiteSurveyHeaderContainer = styled.div<{ theme: { token: CustomThemeToken }; isHomePage?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  align-self: stretch;
  width: 100%;
  background-color: ${({ theme: { token } }) => token.colorBgLayout};
  flex-shrink: 0;

  .close-modal-title {
    color: ${({ theme: { token } }) => token.colorTextLightSolid};
    font-size: 2.375rem;
    color: 'red';
    font-weight: 600;
    line-height: 2.875rem;
  }

  .close-modal-body {
    margin-top: 3px;
    color: red;
  }

  .mobile-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-bottom: 0.5rem;
    padding-top: 1.5rem;

    @media (min-width: ${breakpoints.md}px) {
      padding: 2rem 1.5rem 0 1.5rem;
    }
  }

  .main-content-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 2rem 1.5rem;
    width: 100%;

    @media (max-width: ${breakpoints.md - 1}px) {
      padding: 0.5rem;
    }
  }

  .left-section {
    min-width: 5rem;
    max-width: 5.8125rem;
    width: 10%;
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0.625rem;

    @media (max-width: ${breakpoints.lg - 1}px) {
      display: flex;
      width: auto;
      min-width: auto;
    }
  }

  .back-button {
    color: ${({ theme: { token } }) => token.colorPrimary};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    height: 40px;

    &:hover {
      color: ${({ theme: { token } }) => token.colorPrimaryHover};
    }

    .anticon {
      font-size: 16px;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .button-text {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }
  }

  .steps-section {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 44.375rem;
    position: relative;

    @media (min-width: ${breakpoints.lg}px) {
      width: 80%;
    }
  }

  .site-survey-steps {
    width: 100%;

    ${({ isHomePage, theme: { token } }) =>
      isHomePage &&
      `
   .ant-steps-item-icon {
     background-color: ${token.colorPrimary};
     border-color: ${token.colorPrimary};
   }
   
   .ant-steps-item-icon .ant-steps-icon {
     color: ${token.colorWhite};
   }
   
   .ant-steps-item-tail::after {
     background-color: ${token.colorPrimary};
   }
   
   .ant-steps-item-title {
     color: ${token.colorPrimary};
   }
 `}
  }

  .right-section {
    min-width: 5rem;
    max-width: 6.1875rem;
    width: 10%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    display: inline-flex;

    @media (max-width: ${breakpoints.lg - 1}px) {
      display: flex;
      width: auto;
      min-width: auto;
      padding: 0;
    }
  }

  .close-button {
    width: 100%;
    height: 100%;
    color: ${({ theme: { token } }) => token.colorPrimary};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    background: ${({ theme: { token } }) => token.colorTransparent};
    display: flex;
    justify-content: center;
    align-items: center;

    .anticon {
      font-size: 16px;
      width: 16px;
      height: 16px;
      color: ${({ theme: { token } }) => token.colorPrimary};
    }

    .close-text {
      color: ${({ theme: { token } }) => token.colorPrimary};
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      word-wrap: break-word;
    }

    &:hover {
      color: ${({ theme: { token } }) => token.colorPrimaryHover};
      background: ${({ theme: { token } }) => token.colorTransparent};

      .anticon {
        color: ${({ theme: { token } }) => token.colorPrimaryHover};
      }
    }
  }

  .button-container {
    height: 2.5rem;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    display: inline-flex;
  }

  .button-inner-container {
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    display: inline-flex;

    > div {
      height: 40px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      gap: 8px;
    }
  }

  .steps-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 44.375rem;
    position: relative;

    @media (min-width: ${breakpoints.lg}px) {
      width: 80%;
    }

    .site-survey-steps {
      width: 100%;
    }

    .ant-steps-item-container .ant-steps-item-icon .ant-steps-icon {
      .ant-steps-icon-dot {
        background-color: ${({ theme: { token } }) => token.colorPrimary};
      }
    }

    @media screen and (max-width: ${breakpoints.md - 1}px) {
      .ant-steps {
        flex-direction: row;
        white-space: nowrap;
      }

      .ant-steps-item {
        flex: 1;
        padding: 0 4px;
        margin: 0;
      }

      .ant-steps-item-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }

      .ant-steps-item-title {
        padding-right: 0;
        margin-top: 8px;
        font-size: 12px;
        line-height: 1.2;
        text-align: center;
        white-space: normal;
        max-width: 100px;
      }

      .ant-steps-item-tail {
        display: none;
      }

      .ant-steps-item-icon {
        margin: 0 auto;
      }
    }

    ${({ isHomePage, theme: { token } }) =>
      isHomePage &&
      `
    .ant-steps-item-icon {
      background-color: ${token.colorPrimary};
      border-color: ${token.colorPrimary};
    }
    
    .ant-steps-item-icon .ant-steps-icon {
      color: ${token.colorWhite};
    }
    
    .ant-steps-item-tail::after {
      background-color: ${token.colorPrimary};
    }
    
    .ant-steps-item-title {
      color: ${token.colorPrimary};
    }
  `}
  }
`;
